/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */

import ErrorAlert from "../components/PantallesBKI/Alertas/ErrorAlert";
import { useNavigate } from "react-router-dom";
import { postRequeriment } from "../serveis/serveiRequeriment";

export function useRequeriment() {
  const navigate = useNavigate();

  const postDades = async (data) => {
    try {
      const dades = await postRequeriment(data);

      if (data != null) {
        localStorage.setItem("dadesRequeriment", JSON.stringify(dades));
        navigate("/dadesPeticio");
      }
    } catch (error) {
      ErrorAlert(
        "No s'han trobat resultats amb les dades proporcionades.",
        10000
      );
    }
  };

  return {
    postDades,
  };
}

